export default "__VITE_ASSET__HIkJjqq9__"